package ru.villawonka.app.domain.di

import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module
import ru.villawonka.app.domain.service.FavoritesService
import ru.villawonka.app.domain.usecase.*

val domainModule = module {
    factoryOf(::RequestSearchCategoriesUseCase)
    factoryOf(::RequestSearchResultUseCase)
    factoryOf(::RequestPostByIdUseCase)
    factoryOf(::GetUserCountryUseCase)
    factoryOf(::RequestFavoritePostsUseCase)

    factoryOf(::GetUserSettingsUseCase)
    factoryOf(::UpdateUserSettingsUseCase)
    factoryOf(::IsNewUserUseCase)

    factoryOf(::GetAvailableCurrenciesUseCase)
    factoryOf(::GetAvailableLanguagesUseCase)
    factoryOf(::GetAvailableCountriesUseCase)

    factoryOf(::LikePostUseCase)
    factoryOf(::DislikePostUseCase)

    singleOf(::FavoritesService)
}